module.exports = __webpack_public_path__ + "static/media/canWrong.feea0408.png";